import { envVars } from '@/config';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { cupApi, cupReducer } from './cups';
import { globalApi, globalReducer } from './global';
import { historyApi, historyReducer } from './history';
import { modalityApi } from './modality';
import { competitionTypeReducer, competitionTypesApi } from './competition-types';

export const store = configureStore({
  reducer: {
    global: globalReducer,
    history: historyReducer,
    cup: cupReducer,
    competitionTypes: competitionTypeReducer,
    [cupApi.reducerPath]: cupApi.reducer,
    [modalityApi.reducerPath]: modalityApi.reducer,
    [globalApi.reducerPath]: globalApi.reducer,
    [historyApi.reducerPath]: historyApi.reducer,
    [competitionTypesApi.reducerPath]: competitionTypesApi.reducer,
  },
  devTools: !envVars.prod,
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({ serializableCheck: false }).concat(
      globalApi.middleware,
      modalityApi.middleware,
      historyApi.middleware,
      cupApi.middleware,
      competitionTypesApi.middleware,
    );
  },
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
